import Env from "../base/env";
import Component from "gia/Component";
import gsap from "gsap";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.VARS = {};
    this.VARS.skinValue = this.DOM.view.getAttribute("data-skin");
    this.VARS.skinTrigger = this.DOM.view.getAttribute("data-scroll-trigger");
    this.VARS.skinType = this.DOM.view.getAttribute("data-type");
    this.VARS.skinSwitch = this.DOM.view.getAttribute("data-switch");

    gsap.delayedCall(0.2, () => {
      this.setup();
    });
  }

  setup() {
    this.options = {};
    if (this.VARS.skinType == "top") {
      this.options = {
        onEnter: () => {
          if (this.VARS.skinSwitch == "on") {
            Env.$html.classList.add(this.VARS.skinValue);
          }
          if (this.VARS.skinSwitch == "off") {
            Env.$html.classList.remove(this.VARS.skinValue);
          }
        },
        onEnterBack: () => {
          if (this.VARS.skinSwitch == "on-back") {
            Env.$html.classList.add(this.VARS.skinValue);
          }
          if (this.VARS.skinSwitch == "off-back") {
            Env.$html.classList.remove(this.VARS.skinValue);
          }
        },
      };
      this.options.start = "top top";
    } else if (this.VARS.skinType == "bottom") {
      this.options = {
        onEnter: () => {
          if (this.VARS.skinSwitch == "off") {
            Env.$html.classList.remove(this.VARS.skinValue);
          }
        },
        onEnterBack: () => {
          if (this.VARS.skinSwitch == "off-back") {
            Env.$html.classList.remove(this.VARS.skinValue);
          }
        },
      };
      this.options.start = "top top";
    }

    if (typeof this.DOM.view.dataset.offsetStart != "undefined") {
      this.options.start = this.DOM.view.dataset.offsetStart;
    }

    this.options.trigger = this.DOM.view;
    this.options.markers = false;
    this.st = ScrollTrigger.create(this.options);
  }

  unmount() {
    this.st.kill(true);
    Env.$html.classList.remove(this.VARS.skinValue);
  }
}
